function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M14.67,8.17l34.56-.04c2.11.13,2.36,3.17.24,3.57H15.22c-2.89-.14-4.87,2.58-3.72,5.27,1.08,2.54,4.53,1.98,6.82,1.98,10.79.03,21.61-.08,32.45-.13.33,0,1.32.02,1.61.06.92.12,1.68.72,1.78,1.68l.03,9.25c.11.46.61.56.93.85,1.31,1.22.73,3.75.73,5.35,0,1.47.14,3.07.1,4.52-.03,1.15-.29,1.7-1.07,2.49-.24.24-.65.33-.71.71l.05,10.3c-.14.93-.82,1.66-1.77,1.77-1.27.14-2.76-.02-4.04,0-11.65.08-23.31-.05-34.96.01-3.14-.49-5.18-2.99-5.41-6.12V14.98c.29-3.68,2.93-6.52,6.64-6.8ZM44.02,31.47c-4.97.67-5.52,8.27-1.1,9.84,1.61.57,7.48.49,9.4.36.94-.06,1.28.01,1.37-1.01.17-2.14.19-6.21,0-8.33-.05-.5-.17-.93-.77-.89-2.8.26-6.16-.33-8.89.04Z"
});

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M52.21,16.89c-.17.17-.5.28-.7.43l-37.23.09c-2.21-.24-2.11-3.44,0-3.69h36.62c1.65-.08,2.43,2.06,1.32,3.17Z"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  d: "M44.14,34.56c2.9-.47,3.35,3.93.55,4.12s-2.77-3.76-.55-4.12Z"
});

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 64 64"
  }, props), _ref, _ref2, _ref3);
};

export default __webpack_public_path__ + "static/media/Wallet-filled.22bb5e33.svg";
export { SvgComponent as ReactComponent };